import "core-js/modules/es.array.push.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/esnext.iterator.some.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = ["src"];
import { GLOBAL_DATA } from '@/component-create/utils/global-enum';
import { ElNotification } from 'element-plus';
import 'element-plus/es/components/notification/style/css'

import { FORM_ITEM } from '../form/enums';
import global from '@/component-create/utils/global';
import { log } from '@/component-create/utils/log';
import XSelect from '../x-select/XSelect.vue';
import { Plus } from '@element-plus/icons-vue';

import { ref, toRefs, onMounted } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'XForm',
  props: {
    items: {},
    elFormProps: {
      default: () => ({})
    },
    saveUrl: {},
    loadUrl: {},
    loaded: {
      type: Boolean
    },
    saveMethods: {},
    handler: {},
    getInstance: {}
  },
  setup(__props) {
    const prop = __props;
    const formData = ref({});
    const elFormRef = ref();
    const {
      items,
      elFormProps,
      saveUrl,
      loadUrl,
      saveMethods
    } = toRefs(prop);
    const SAVE = global.globalVal[GLOBAL_DATA.FORM_REQUEST_SAVE];
    const LOAD = global.globalVal[GLOBAL_DATA.FORM_REQUEST_LOAD];
    const loading = ref(false);
    const instance = new Proxy({}, {});
    const hideKey = ref([]);
    const defaultValue = ref({});
    const customSaveParams = ref({});
    prop.getInstance?.(instance);
    instance.setFormData = setFormData;
    instance.getFormData = getFormData;
    instance.getFormDataNotValidate = getFormDataNotValidate;
    instance.save = save;
    instance.load = load;
    instance.showLoading = showLoading;
    instance.closeLoading = closeLoading;
    instance.updateFormData = updateFormData;
    instance.hideFormItemByKey = hideFormItemByKey;
    instance.showFormItemByKey = showFormItemByKey;
    instance.reset = reset;
    instance.setSaveParams = setSaveParams;
    onMounted(() => {
      instance.elFormInstance = elFormRef.value;
      defaultValue.value = {
        ...formData.value
      };
    });
    /**
     * 构造虚拟下拉框的选项
     */
    function getVirtualizedSelectOptions(options, labelKey, valueKey) {
      return options.map(item => ({
        label: item[labelKey],
        value: item[valueKey]
      }));
    }
    /**
     * 上传
     */
    function beforeUpload(file, key) {
      if (file.type.includes('image')) {
        const blob = new Blob([file]);
        formData.value[key] = URL.createObjectURL(blob);
      } else {
        ElNotification({
          type: 'error',
          title: '错误',
          message: '仅支持图片上传'
        });
      }
      return false;
    }
    /**
     * 设置表单数据
     */
    function setFormData(data) {
      formData.value = data;
    }
    function setSaveParams(data) {
      customSaveParams.value = data;
    }
    /**
     * 重置表单
     */
    function reset() {
      formData.value = {
        ...defaultValue.value
      };
    }
    /**
     * 更新表单数据
     */
    function updateFormData(data) {
      formData.value = {
        ...formData.value,
        ...data
      };
    }
    /**
     * 获取表单数据
     */
    function getFormData() {
      return new Promise((resolve, reject) => {
        if (!elFormRef.value) {
          log('XForm', '表单实例未找到', 'error');
          reject('表单实例未找到');
        } else {
          elFormRef.value.validate(valid => {
            if (valid) {
              resolve(formData.value);
            } else {
              reject('校验未通过');
            }
          });
        }
      });
    }
    /**
     * 获取表单数据，不校验
     */
    function getFormDataNotValidate() {
      return formData.value;
    }
    /**
     * 保存
     */
    function save(success, error, validateFail) {
      if (!saveUrl?.value) {
        log('XForm', '未配置API地址', 'error');
        return;
      }
      if (SAVE) {
        getFormData().then(() => {
          showLoading();
          SAVE(saveUrl.value, {
            ...(customSaveParams.value || {}),
            ...formData.value
          }, saveMethods?.value || 'post').then(() => {
            ElNotification({
              title: '成功',
              type: 'success',
              message: '保存成功'
            });
            closeLoading();
            success?.(formData.value);
          }).catch(() => {
            // ElNotification({
            //   title: '失败',
            //   type: 'error',
            //   message: '保存失败'
            // })
            closeLoading();
            error?.();
          });
        }).catch(error => {
          validateFail?.();
        });
      } else {
        log('XForm', '保存失败，未配置表单保存服务接口：' + GLOBAL_DATA.FORM_REQUEST_SAVE, 'error');
      }
    }
    /**
     * 隐藏表单项
     */
    function hideFormItemByKey(key) {
      if (typeof key === 'string') {
        hideKey.value.push(key);
        if (formData.value[key] !== undefined) {
          formData.value[key] = undefined;
        }
      } else {
        hideKey.value.push(...key);
        key.forEach(k => {
          if (formData.value[k] !== undefined) {
            formData.value[k] = undefined;
          }
        });
      }
      hideKey.value = [...new Set(hideKey.value)];
    }
    /**
     * 显示表单项
     */
    function showFormItemByKey(key) {
      if (typeof key === 'string') {
        const i = hideKey.value.findIndex(hkey => hkey === key);
        if (i > -1) {
          hideKey.value.splice(i, 1);
        }
      } else {
        key.forEach(k => {
          const i = hideKey.value.findIndex(hkey => hkey === k);
          if (i > -1) {
            hideKey.value.splice(i, 1);
          }
        });
      }
      hideKey.value = [...hideKey.value];
    }
    function load(data) {
      return new Promise((resolve, reject) => {
        if (loadUrl?.value) {
          showLoading();
          LOAD(loadUrl.value, data).then(res => {
            formData.value = res.data;
            closeLoading();
            resolve(res.data);
          }).catch(() => {
            closeLoading();
            reject(false);
          });
        } else {
          reject(false);
        }
      });
    }
    function renderCustomItem(fn) {
      return fn(formData);
    }
    function showLoading() {
      loading.value = true;
    }
    function closeLoading() {
      loading.value = false;
    }
    return (_ctx, _cache) => {
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_autocomplete = _resolveComponent("el-autocomplete");
      const _component_el_cascader = _resolveComponent("el-cascader");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
      const _component_el_color_picker = _resolveComponent("el-color-picker");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_radio_button = _resolveComponent("el-radio-button");
      const _component_el_rate = _resolveComponent("el-rate");
      const _component_el_select_v2 = _resolveComponent("el-select-v2");
      const _component_el_slider = _resolveComponent("el-slider");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_time_picker = _resolveComponent("el-time-picker");
      const _component_el_time_select = _resolveComponent("el-time-select");
      const _component_el_transfer = _resolveComponent("el-transfer");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_form = _resolveComponent("el-form");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createBlock(_component_el_form, _mergeProps(_unref(elFormProps), {
        model: _unref(formData),
        ref_key: "elFormRef",
        ref: elFormRef
      }), {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), (item, index) => {
          return _openBlock(), _createElementBlock(_Fragment, {
            key: index
          }, [item.length > 0 && item.some(col => col && (!col.key || !_unref(hideKey).includes(col.key))) ? (_openBlock(), _createBlock(_component_el_row, {
            key: 0,
            gutter: 20
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (elItem, i) => {
              return _openBlock(), _createElementBlock(_Fragment, {
                key: i
              }, [!elItem ? (_openBlock(), _createBlock(_component_el_col, {
                key: 0,
                span: 24 / item.length
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item)]),
                _: 2
              }, 1032, ["span"])) : !_unref(hideKey).includes(elItem.key) ? (_openBlock(), _createBlock(_component_el_col, {
                key: 1,
                span: 24 / item.length
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: elItem.label,
                  prop: elItem.key
                }, {
                  default: _withCtx(() => [elItem.el === _unref(FORM_ITEM).INPUT ? (_openBlock(), _createBlock(_component_el_input, _mergeProps({
                    key: 0,
                    class: "full",
                    modelValue: _unref(formData)[elItem.key],
                    "onUpdate:modelValue": $event => _unref(formData)[elItem.key] = $event,
                    ref_for: true
                  }, {
                    placeholder: '请输入' + elItem.label,
                    ...(elItem.props || {})
                  }), null, 16, ["modelValue", "onUpdate:modelValue"])) : elItem.el === _unref(FORM_ITEM).EL_SELECT ? (_openBlock(), _createBlock(_component_el_select, _mergeProps({
                    key: 1,
                    modelValue: _unref(formData)[elItem.key],
                    "onUpdate:modelValue": $event => _unref(formData)[elItem.key] = $event,
                    class: "full",
                    ref_for: true
                  }, {
                    placeholder: '请选择' + elItem.label,
                    ...(elItem.props || {})
                  }), {
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(elItem.options || [], option => {
                      return _openBlock(), _createBlock(_component_el_option, {
                        key: option[elItem.labelKey || 'value'],
                        label: option[elItem.labelKey || 'label'],
                        value: option[elItem.valueKey || 'value']
                      }, null, 8, ["label", "value"]);
                    }), 128))]),
                    _: 2
                  }, 1040, ["modelValue", "onUpdate:modelValue"])) : elItem.el === _unref(FORM_ITEM).SELECT ? (_openBlock(), _createBlock(XSelect, _mergeProps({
                    key: 2,
                    modelValue: _unref(formData)[elItem.key],
                    "onUpdate:modelValue": $event => _unref(formData)[elItem.key] = $event,
                    class: "full",
                    ref_for: true
                  }, {
                    placeholder: '请选择' + elItem.label,
                    ...(elItem.props || {})
                  }), null, 16, ["modelValue", "onUpdate:modelValue"])) : elItem.el === _unref(FORM_ITEM).AUTOCOMPLETE ? (_openBlock(), _createBlock(_component_el_autocomplete, _mergeProps({
                    key: 3,
                    class: "full",
                    modelValue: _unref(formData)[elItem.key],
                    "onUpdate:modelValue": $event => _unref(formData)[elItem.key] = $event,
                    ref_for: true
                  }, {
                    placeholder: '请输入' + elItem.label,
                    ...(elItem.props || {})
                  }), null, 16, ["modelValue", "onUpdate:modelValue"])) : elItem.el === _unref(FORM_ITEM).CASCADER ? (_openBlock(), _createBlock(_component_el_cascader, _mergeProps({
                    key: 4,
                    class: "full",
                    modelValue: _unref(formData)[elItem.key],
                    "onUpdate:modelValue": $event => _unref(formData)[elItem.key] = $event,
                    ref_for: true
                  }, {
                    placeholder: '请选择' + elItem.label,
                    ...(elItem.props || {})
                  }), null, 16, ["modelValue", "onUpdate:modelValue"])) : elItem.el === _unref(FORM_ITEM).CHECKBOX ? (_openBlock(), _createBlock(_component_el_checkbox_group, _mergeProps({
                    key: 5,
                    modelValue: _unref(formData)[elItem.key],
                    "onUpdate:modelValue": $event => _unref(formData)[elItem.key] = $event,
                    ref_for: true
                  }, elItem.props || {}), {
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(elItem.options || [], option => {
                      return _openBlock(), _createBlock(_component_el_checkbox, {
                        key: option[elItem.labelKey || 'value'],
                        label: option[elItem.valueKey || 'value']
                      }, {
                        default: _withCtx(() => [_createTextVNode(_toDisplayString(option[elItem.labelKey || 'label']), 1)]),
                        _: 2
                      }, 1032, ["label"]);
                    }), 128))]),
                    _: 2
                  }, 1040, ["modelValue", "onUpdate:modelValue"])) : elItem.el === _unref(FORM_ITEM).COLOR_PICKER ? (_openBlock(), _createBlock(_component_el_color_picker, _mergeProps({
                    key: 6,
                    modelValue: _unref(formData)[elItem.key],
                    "onUpdate:modelValue": $event => _unref(formData)[elItem.key] = $event,
                    ref_for: true
                  }, elItem.props || {}), null, 16, ["modelValue", "onUpdate:modelValue"])) : elItem.el === _unref(FORM_ITEM).DATE_PICKER ? (_openBlock(), _createBlock(_component_el_date_picker, _mergeProps({
                    key: 7,
                    class: "full",
                    modelValue: _unref(formData)[elItem.key],
                    "onUpdate:modelValue": $event => _unref(formData)[elItem.key] = $event,
                    ref_for: true
                  }, {
                    placeholder: '请选择' + elItem.label,
                    ...(elItem.props || {})
                  }, {
                    type: "date"
                  }), null, 16, ["modelValue", "onUpdate:modelValue"])) : elItem.el === _unref(FORM_ITEM).DATETIME_PICKER ? (_openBlock(), _createBlock(_component_el_date_picker, _mergeProps({
                    key: 8,
                    class: "full",
                    modelValue: _unref(formData)[elItem.key],
                    "onUpdate:modelValue": $event => _unref(formData)[elItem.key] = $event,
                    ref_for: true
                  }, {
                    placeholder: '请选择' + elItem.label,
                    ...(elItem.props || {})
                  }, {
                    type: "datetime"
                  }), null, 16, ["modelValue", "onUpdate:modelValue"])) : elItem.el === _unref(FORM_ITEM).INPUT_NUMBER ? (_openBlock(), _createBlock(_component_el_input_number, _mergeProps({
                    key: 9,
                    class: "full",
                    modelValue: _unref(formData)[elItem.key],
                    "onUpdate:modelValue": $event => _unref(formData)[elItem.key] = $event,
                    ref_for: true
                  }, {
                    placeholder: '请输入' + elItem.label,
                    ...(elItem.props || {})
                  }), null, 16, ["modelValue", "onUpdate:modelValue"])) : elItem.el === _unref(FORM_ITEM).RADIO ? (_openBlock(), _createBlock(_component_el_radio_group, _mergeProps({
                    key: 10,
                    modelValue: _unref(formData)[elItem.key],
                    "onUpdate:modelValue": $event => _unref(formData)[elItem.key] = $event,
                    ref_for: true
                  }, elItem.props || {}), {
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(elItem.options || [], option => {
                      return _openBlock(), _createBlock(_component_el_radio, {
                        key: option[elItem.labelKey || 'value'],
                        label: option[elItem.valueKey || 'value']
                      }, {
                        default: _withCtx(() => [_createTextVNode(_toDisplayString(option[elItem.labelKey || 'label']), 1)]),
                        _: 2
                      }, 1032, ["label"]);
                    }), 128))]),
                    _: 2
                  }, 1040, ["modelValue", "onUpdate:modelValue"])) : elItem.el === _unref(FORM_ITEM).RADIO_BUTTON ? (_openBlock(), _createBlock(_component_el_radio_group, _mergeProps({
                    key: 11,
                    modelValue: _unref(formData)[elItem.key],
                    "onUpdate:modelValue": $event => _unref(formData)[elItem.key] = $event,
                    ref_for: true
                  }, elItem.props || {}), {
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(elItem.options || [], option => {
                      return _openBlock(), _createBlock(_component_el_radio_button, {
                        key: option[elItem.labelKey || 'value'],
                        label: option[elItem.valueKey || 'value']
                      }, {
                        default: _withCtx(() => [_createTextVNode(_toDisplayString(option[elItem.labelKey || 'label']), 1)]),
                        _: 2
                      }, 1032, ["label"]);
                    }), 128))]),
                    _: 2
                  }, 1040, ["modelValue", "onUpdate:modelValue"])) : elItem.el === _unref(FORM_ITEM).RATE ? (_openBlock(), _createBlock(_component_el_rate, _mergeProps({
                    key: 12,
                    modelValue: _unref(formData)[elItem.key],
                    "onUpdate:modelValue": $event => _unref(formData)[elItem.key] = $event,
                    ref_for: true
                  }, elItem.props || {}), null, 16, ["modelValue", "onUpdate:modelValue"])) : elItem.el === _unref(FORM_ITEM).VIRTUALIZED_SELECT ? (_openBlock(), _createBlock(_component_el_select_v2, _mergeProps({
                    key: 13,
                    class: "full",
                    modelValue: _unref(formData)[elItem.key],
                    "onUpdate:modelValue": $event => _unref(formData)[elItem.key] = $event,
                    options: getVirtualizedSelectOptions(elItem.options || [], elItem.labelKey || 'label', elItem.valueKey || 'value'),
                    ref_for: true
                  }, {
                    placeholder: '请选择' + elItem.label,
                    ...(elItem.props || {})
                  }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])) : elItem.el === _unref(FORM_ITEM).SLIDER ? (_openBlock(), _createBlock(_component_el_slider, _mergeProps({
                    key: 14,
                    class: "full",
                    modelValue: _unref(formData)[elItem.key],
                    "onUpdate:modelValue": $event => _unref(formData)[elItem.key] = $event,
                    ref_for: true
                  }, elItem.props || {}), null, 16, ["modelValue", "onUpdate:modelValue"])) : elItem.el === _unref(FORM_ITEM).SWITCH ? (_openBlock(), _createBlock(_component_el_switch, _mergeProps({
                    key: 15,
                    modelValue: _unref(formData)[elItem.key],
                    "onUpdate:modelValue": $event => _unref(formData)[elItem.key] = $event,
                    ref_for: true
                  }, elItem.props || {}), null, 16, ["modelValue", "onUpdate:modelValue"])) : elItem.el === _unref(FORM_ITEM).TIME_PICKER ? (_openBlock(), _createBlock(_component_el_time_picker, _mergeProps({
                    key: 16,
                    class: "full",
                    modelValue: _unref(formData)[elItem.key],
                    "onUpdate:modelValue": $event => _unref(formData)[elItem.key] = $event,
                    ref_for: true
                  }, {
                    placeholder: '请选择' + elItem.label,
                    ...(elItem.props || {})
                  }), null, 16, ["modelValue", "onUpdate:modelValue"])) : elItem.el === _unref(FORM_ITEM).TIME_SELECT ? (_openBlock(), _createBlock(_component_el_time_select, _mergeProps({
                    key: 17,
                    class: "full",
                    modelValue: _unref(formData)[elItem.key],
                    "onUpdate:modelValue": $event => _unref(formData)[elItem.key] = $event,
                    ref_for: true
                  }, {
                    placeholder: '请选择' + elItem.label,
                    ...(elItem.props || {})
                  }), null, 16, ["modelValue", "onUpdate:modelValue"])) : elItem.el === _unref(FORM_ITEM).TRANSFER ? (_openBlock(), _createBlock(_component_el_transfer, _mergeProps({
                    key: 18,
                    modelValue: _unref(formData)[elItem.key],
                    "onUpdate:modelValue": $event => _unref(formData)[elItem.key] = $event,
                    ref_for: true
                  }, elItem.props || {}), null, 16, ["modelValue", "onUpdate:modelValue"])) : elItem.el === _unref(FORM_ITEM).UPLOAD ? (_openBlock(), _createBlock(_component_el_upload, _mergeProps({
                    key: 19,
                    ref_for: true
                  }, elItem.props || {}, {
                    class: "avatar-uploader",
                    "before-upload": e => beforeUpload(e, elItem.key),
                    accept: ".gif,.jpg,.jpeg,.png,.GIF,.JPG,.PNG"
                  }), {
                    default: _withCtx(() => [_unref(formData)[elItem.key] ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      style: {
                        "width": "100%",
                        "height": "100%",
                        "object-fit": "cover"
                      },
                      src: _unref(formData)[elItem.key],
                      class: "avatar"
                    }, null, 8, _hoisted_1)) : (_openBlock(), _createBlock(_component_el_icon, {
                      key: 1,
                      class: "avatar-uploader-icon"
                    }, {
                      default: _withCtx(() => [_createVNode(_unref(Plus))]),
                      _: 1
                    }))]),
                    _: 2
                  }, 1040, ["before-upload"])) : typeof elItem.el === 'function' ? (_openBlock(), _createBlock(_resolveDynamicComponent(renderCustomItem(elItem.el)), _mergeProps({
                    key: 20,
                    class: "full",
                    ref_for: true
                  }, elItem.props || {}), null, 16)) : (_openBlock(), _createBlock(_resolveDynamicComponent(elItem.el), _mergeProps({
                    key: 21,
                    class: "full",
                    modelValue: _unref(formData)[elItem.key],
                    "onUpdate:modelValue": $event => _unref(formData)[elItem.key] = $event,
                    ref_for: true
                  }, elItem.props || {}), null, 16, ["modelValue", "onUpdate:modelValue"]))]),
                  _: 2
                }, 1032, ["label", "prop"])]),
                _: 2
              }, 1032, ["span"])) : _createCommentVNode("", true)], 64);
            }), 128))]),
            _: 2
          }, 1024)) : _createCommentVNode("", true)], 64);
        }), 128))]),
        _: 1
      }, 16, ["model"])), [[_directive_loading, _unref(loading)]]);
    };
  }
});